import { z } from "zod";
export const getMessageSchema = (t, opts) => {
    const { isMessageRequired, isPrivateOwner } = opts;
    if (isMessageRequired && isPrivateOwner) {
        return z.object({
            message: z
                .string()
                .min(10, { message: t("contact.form.subject_error_empty") })
                .max(2500, { message: t("contact.form.subject_error_length") }),
        });
    }
    return z.object({
        message: z
            .string()
            .max(2500, { message: t("contact.form.subject_error_length") })
            .optional(),
    });
};
